import {Vue} from 'ui.vue';
import {Input} from 'phone_number';


import './BXmakerAuthuserphoneInputPhone.styl';

/**
 * @event onEnter {value:string} ��� ������� �� enter
 * @event onInput {value:string}
 * @event onFocus {}
 * @event onBlur {}
 */
Vue.component('BXmakerAuthuserphoneInputPhone',
    {
        props: {
            title: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ()=>{
                    return Math.random().toString(16).substring(2, 8) + '_' + (new Date).getTime();
                }
            },
            type: {
                type: String,
                default: 'text'
            },
            validationMessage: {
                type: [String, Boolean],
                default: false
            },
            maxLength: {
                type: [Number, Boolean],
                default: false
            },
            mask: {
                type: [Array, Object, Boolean],
                default: () => []
            },
            as: {
                type: String,
                default: ''
            },

        },
        data: function () {
            return {
                inFocus: false, // � ������ ����
                isHover: false, // ������� ������
                isInit: false, // ��������� ������ �� �������
                placeholder: '', //����������� ��� ���������
                isSet: false, // ��������������� �������������� ��������
            };
        },
        beforeDestroy() {
            BX.removeCustomEvent('onAjaxSuccess', this.onAjaxSuccess);
        },
        mounted() {
            if(this.mask)
            {
                this._phoneNumber = new BX.PhoneNumber.Input({
                    node: this.$refs.input,
                    flagNode: this.$refs.flag,
                    flagSize: 16, // ������ ����� [16, 24, 32]
                    defaultCountry: this.mask.defaultCountry, // ������ ��-���������
                    countryTopList: this.mask.countryTopList,
                    onChange: (event) => {

                        // if(this._phoneNumber.formatter.isCompleteNumber())
                        // {
                        //     this._phoneNumber.formatter.formatCompleteNumber(this.nationalNumber);
                        // }

                        this.$emit('onChange', event)
                    },
                    onInitialize: (e) => {
                        this.isInit = true;
                    }
                });
            }


            BX.addCustomEvent('onAjaxSuccess', BX.proxy(this.onAjaxSuccess, this));
        },
        computed: {
            classes() {
                let ar = [];

                ar.push('bxmaker-authuserphone-input-phone--flag');

                if (this.inFocus || this.value.length > 0) {
                    ar.push('bxmaker-authuserphone-input-phone--focus');
                }
                if (this.isHover) {
                    ar.push('bxmaker-authuserphone-input-phone--hover');
                }

                if (this.validationMessage) {
                    ar.push('bxmaker-authuserphone-input-phone--invalid');
                }

                return ar;
            },

        },
        methods: {
            onFocus() {
                this.inFocus = true;
                this.$emit('onFocus');
            },
            onBlur() {
                this.inFocus = false;
                this.$emit('onBlur');
            },
            onKeydown(e) {
                switch (e.keyCode) {
                    case 13://enter
                    {
                        this.$emit('onEnter', e.target.value)
                        return;
                    }
                }
            },
            onMouseenter() {
                this.isHover = true;
            },
            onMouseleave() {
                this.isHover = false;
            },
            // ��������� ������ �� ����
            focus() {
                this.$refs.input.focus();
            },
            checkPhoneCountryPopupPosition() {
                setTimeout(() => {
                    let phoneCountryPopup = BX('phoneNumberInputSelectCountry');
                    if (phoneCountryPopup) {
                        BX.style(phoneCountryPopup, 'z-index', '400000');
                    }
                    let phoneCountryPopupBg = BX('popup-window-overlay-phoneNumberInputSelectCountry');
                    if (phoneCountryPopupBg) {
                        BX.style(phoneCountryPopupBg, 'z-index', '3995');
                    }
                }, 5);
            },
            onAjaxSuccess(data, request) {
                if (!request || !request.url || !request.url.match(/action=main\.phonenumber\.getCountries$/)) {
                    return true;
                }
                this.checkPhoneCountryPopupPosition();
            }
        },
        updated() {
            // console.log(this._phoneNumber);

        },
        watch: {
            isInit() {
                this._phoneNumber.formatter.replaceCountry(this.mask.defaultCountry);
            },
            isHover(val) {
                if (val && this.isInit) {
                    this.placeholder = this._phoneNumber.formatter.getFormattedNumber();
                } else {
                    this.placeholder = '';
                }
            },
            inFocus(val) {
                if (val && !this.isSet && this.isInit) {
                    this.isSet = true;
                    this._phoneNumber.setValue(this._phoneNumber.formatter.getFormattedNumber());
                }
            }

        },

        template: `
            <div class="bxmaker-authuserphone-input-phone " :class="classes" >
                <div class="bxmaker-authuserphone-input-phone__field">
                    
                    <div  class="bxmaker-authuserphone-input-phone__flag" >
                        <span ref="flag" @click="checkPhoneCountryPopupPosition"></span>
                    </div>  
                    
                    <div  class="bxmaker-authuserphone-input-phone__input" >
                         <input 
                         :type="type"
                          :name="name" 
                            @focus="onFocus" 
                            @blur="onBlur"                        
                             @mouseenter="onMouseenter" 
                             @mouseleave="onMouseleave" 
                             @keydown="onKeydown" 
                             :value="value"
                              autocomplete="new-password"
                              :maxlength="maxLength"
                              ref="input"
                              key="phone"
                              :placeholder="placeholder"
                              
                          >
                        <span class="bxmaker-authuserphone-input-phone__title">{{title}}</span>            
                    </div>  
                       
                </div>
                <div class="bxmaker-authuserphone-input-phone__validation" v-if="validationMessage">{{validationMessage}}</div>                
            </div>
        `,
    });